import { render } from "./AddFooterImages.vue?vue&type=template&id=cf3242f4"
import script from "../js/add-footer-images.js?vue&type=script&lang=js"
export * from "../js/add-footer-images.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__